export const SUPPORTED_FIAT_CURRENCIES = [
    "USD",
    "EUR",
    "RUB",
    "UAH",
    "KZT",
    "PLN",
    "GBP",
    "TRY",
    "AED",
]

export const SUPPORTED_CRYPTO_CURRENCIES = [
    "USDT",
    "BTC",
    "ETH",
]

export const DISPLAY_CURRENCY_OPTIONS = [
    ...SUPPORTED_FIAT_CURRENCIES,
    "USDT",
].map((currency) => ({
    value: currency,
    label: currency,
}))

export const FEATURED_MARKET_RATE_BASES = [
    ...SUPPORTED_FIAT_CURRENCIES,
    ...SUPPORTED_CRYPTO_CURRENCIES,
]